var config = {}

config.logging =  {}

config.logging.enabled = (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test")

module.exports = config